import React, { useEffect, useState, useContext } from "react";
import { ServerContext } from "../App";
import { getMatchesCard } from "../services/ScheduleService";
import { connectToMatch, connectToLiveMatches, disconnectFromMatch } from "../services/WebSocketService";
import LiveHero from "../components/Home/LiveHero";
import LiveMatchCard from "../components/Home/LiveMatchCard";
import ScheduleCard from "../components/Home/ScheduleCard";
import Sidebar from "../components/Home/Sidebar";
import CompletedMatchCard from "../components/Home/CompletedMatchCard";//4greg//rgertrh
import { getLiveScore } from "../services/ScheduleService";

function Home({ token, userName }) {
    const { selectedServerIds } = useContext(ServerContext);
    const [liveMatches, setLiveMatches] = useState([]);
    const lastWsUpdateRef = React.useRef({});
    const selectedServerIdsRef = React.useRef(selectedServerIds);
    useEffect(() => {
        selectedServerIdsRef.current = selectedServerIds;
    }, [selectedServerIds]);
    const [heroLoading, setHeroLoading] = useState(true);
    const [liveScores, setLiveScores] = useState({});
    const [completedMatches, setCompletedMatches] = useState([]);
    const [upcomingMatches, setUpcomingMatches] = useState([]);
    const [activeTab, setActiveTab] = useState("live");

    useEffect(() => {
        connectToLiveMatches(1, (data) => {
            if (data && data.matches) {
                // console.log('Live matches received:', data.matches.length);
                const currentServerIds = selectedServerIdsRef.current;
                const actualLive = data.matches.filter(m =>
                    !m.matchEndTime &&
                    (currentServerIds.length === 0 || currentServerIds.includes(m.tenantId))
                );
                setLiveMatches(actualLive);
                actualLive.forEach((match) => {
                    connectToMatch(match.matchId, (message) => {
                        //console.log(`[${new Date().toLocaleTimeString()}] 🏏 Ball update for match ${message.matchId}:`, message);
                        lastWsUpdateRef.current[message.matchId] = Date.now();
                        setLiveScores(prev => {
                            const existing = prev[message.matchId];
                            const newBall = {
                                actionOutCome: message.actionOutCome,
                                numberOfOver: message.over,
                                ballOfOver: message.ballOfOver,
                                inningId: message.inning
                            };
                            const inning1Balls = message.inning === 1
                                ? [...(existing?.inning1Balls || []), newBall]
                                : (existing?.inning1Balls || []);
                            const inning2Balls = message.inning === 2
                                ? [...(existing?.inning2Balls || []), newBall]
                                : (existing?.inning2Balls || []);
                            // console.log(`inning=${message.inning} inning1Balls=${inning1Balls.length} inning2Balls=${inning2Balls.length}`);
                            const inning1Score = message.inning === 2
                                ? (existing?.inning === 1 ? existing?.score : existing?.inning1Score)
                                : null;
                            const inning1Wickets = message.inning === 2
                                ? (existing?.inning === 1 ? existing?.wicketCount : existing?.inning1Wickets)
                                : null;
                            return {
                                ...prev,
                                [message.matchId]: {
                                    ...message,
                                    inning1Balls,
                                    inning2Balls,
                                    inning1Score,
                                    inning1Wickets
                                }
                            };
                        });
                    });
                });
            }
        });
        const fetchData = () => {
            getMatchesCard("live", 0, 10, null, selectedServerIds).then((data) => {
                setHeroLoading(false);
                if (data && data.matches && data.matches.length > 0) {
                    const actualLive = data.matches.filter(m => !m.matchEndTime);
                    setLiveMatches(actualLive);
                    actualLive.forEach((match) => {
                       // Get snapshot first for missed balls
                        setLiveScores(prev => {
                            const now = Date.now();
                            const lastUpdate = lastWsUpdateRef.current[match.matchId] || 0;
                            const wsActive = (now - lastUpdate) < 30000;
                            if (!wsActive) {
                                getLiveScore(match.matchId).then((snapshot) => {
                                    if (snapshot && snapshot.matchId) {
                                        const inning1Balls = (snapshot.ballSummaryList || []).filter(b => b.inningId === 1);
                                        const inning2Balls = (snapshot.ballSummaryList || []).filter(b => b.inningId === 2);
                                        const inning1Score = snapshot.inning === 2 ? (snapshot.target != null ? snapshot.target - 1 : null) : null;
                                        const inning1Wickets = snapshot.inning === 2 ? inning1Balls.filter(b => b.actionOutCome === "OUT").length : null;
                                        setLiveScores(p => ({
                                            ...p,
                                            [snapshot.matchId]: {
                                                ...snapshot,
                                                inning1Balls,
                                                inning2Balls,
                                                inning1Score,
                                                inning1Wickets
                                            }
                                        }));
                                    }
                                });
                            }
                            return prev;
                        });
                        //WebSocket for new balls
                        connectToMatch(match.matchId, (message) => {
                            //console.log(`🏏 WebSocket score received for match ${message.matchId}:`, message);
                            lastWsUpdateRef.current[message.matchId] = Date.now();
                            setLiveScores(prev => {
                                const existing = prev[message.matchId];
                                const newBall = {
                                    actionOutCome: message.actionOutCome,
                                    numberOfOver: message.over,
                                    ballOfOver: message.ballOfOver,
                                    inningId: message.inning
                                };
                                const inning1Balls = message.inning === 1
                                    ? [...(existing?.inning1Balls || []), newBall]
                                    : (existing?.inning1Balls || []);
                                const inning2Balls = message.inning === 2
                                    ? [...(existing?.inning2Balls || []), newBall]
                                    : (existing?.inning2Balls || []);
                                const inning1Score = message.inning === 2
                                    ? (existing?.inning === 1 ? existing?.score : existing?.inning1Score)
                                    : null;
                                const inning1Wickets = message.inning === 2
                                    ? (existing?.inning === 1 ? existing?.wicketCount : existing?.inning1Wickets)
                                    : null;

                                return {
                                    ...prev,
                                    [message.matchId]: {
                                        ...message,
                                        inning1Balls,
                                        inning2Balls,
                                        inning1Score,
                                        inning1Wickets
                                    }
                                };
                            });
                        });
                    });

                } else {
                    setLiveMatches([]);
                }
            });

            getMatchesCard("completed", 0, 10, null, selectedServerIds).then((data) => {
                if (data && data.matches) {
                    setCompletedMatches(data.matches);
                }
            }).catch((err) => {});

            getMatchesCard("upcoming", 0, 10, "today", selectedServerIds).then((data) => {
                if (data && data.matches) {
                    setUpcomingMatches(data.matches);
                }
            }).catch((err) => {});
        };

        fetchData();
        const interval = setInterval(fetchData, 30000);
        return () => {
            clearInterval(interval);
            disconnectFromMatch();
        };
    }, [selectedServerIds]);

    return (
        <div>
            {liveMatches.length > 0 ? (
                <LiveHero
                    liveMatch={liveMatches[0]}
                    liveScore={liveScores[liveMatches[0].matchId] || null}
                    liveCount={liveMatches.length}
                    onViewAll={() => {
                        setActiveTab("live");
                        const el = document.getElementById("tabs-row");
                        if (el) el.scrollIntoView({ behavior: "smooth" });
                    }}
                />
            ) : (
                <LiveHero liveMatch={null} liveScore={null} liveCount={0} heroLoading={heroLoading} />
            )}

            <div className="tabs-row" id="tabs-row">
                <button className={`tab-btn ${activeTab === "live" ? "active" : ""}`} onClick={() => setActiveTab("live")}>All Live</button>
                <button className={`tab-btn ${activeTab === "completed" ? "active" : ""}`} onClick={() => setActiveTab("completed")}>Completed</button>
                <button className={`tab-btn ${activeTab === "upcoming" ? "active" : ""}`} onClick={() => setActiveTab("upcoming")}>Upcoming</button>
            </div>

            <div id="section-home" className="spanel active">
                <div className="main-wrap">
                    <div className="main-grid">
                        <div>
                            {activeTab === "live" && (
                                <div>
                                    <div className="sh">All Live Matches</div>
                                    {liveMatches.length === 0 && (
                                        <p className="no-matches-msg">No live matches right now.</p>
                                    )}
                                    {liveMatches.map((match) => (
                                        <LiveMatchCard key={match.matchId} match={match} liveScore={liveScores[match.matchId] || null} />
                                    ))}
                                </div>
                            )}

                            {activeTab === "completed" && (
                                <div>
                                    <div className="sh">Recent Completed</div>
                                    {completedMatches.length === 0 && (
                                        <p className="no-matches-msg">No completed matches.</p>
                                    )}
                                    {completedMatches.map((match) => (
                                        <CompletedMatchCard key={match.matchId} match={match} />
                                    ))}
                                </div>
                            )}

                            {activeTab === "upcoming" && (
                                <div>
                                    <div className="sh">Today's Upcoming</div>
                                    {upcomingMatches.length === 0 && (
                                        <p className="no-matches-msg">No upcoming matches today.</p>
                                    )}
                                    {upcomingMatches.map((match, index) => (
                                        <ScheduleCard key={match.matchId} match={match} index={index} />
                                    ))}
                                </div>
                            )}
                        </div>
                        <Sidebar />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;

//jhb